import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';
import packageJson from '../../../../../package.json';

@Component({
  selector: 'app-beta-label',
  templateUrl: './beta-label.component.html',
  standalone: false,
})
export class BetaLabelComponent {
  protected readonly inBeta = environment.inBeta;
  protected readonly version = packageJson.version;
}
